





















 
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { bus } from '../main'

import ProductCard from './ProductCard.vue'

/* eslint-disable */ 
import { Product } from '../models/Product'
/* eslint-enable */ 

import { Category } from '@/enums/category'

import ModelsList from '@/components/ModelsList.vue'
import YearModelSelector from './YearModelSelector.vue'

export default Vue.extend({ 
  computed: {
    cols () : number {
      const { xs, sm, md, lg } = this.$vuetify.breakpoint
      return xs ? 12 : sm ? 6 : md ? 4 : lg ? 3 : 2
    },
    ...mapGetters({
      currentDealer: 'dealers/currentDealer',
      products: 'products/products',
      featuredProducts: 'products/featuredProducts',
      interiorProducts: 'products/interiorProducts',
      exteriorProducts: 'products/exteriorProducts',
      packages: 'products/packages',
      loading: 'products/loading',
      numProducts: 'products/numProducts',
      featuredProductsLength: 'products/featuredProductsLength',
      selectedModelId: 'models/currentModelId'
    }),
    modelDialog: {
      get() : boolean {
        return this.numProducts == 0
      },
      set(value : boolean) : void {
        this.modelDialog = value
      }
    },
    selectedProducts() : Product[] {
      switch(this.category) {
        case Category.FEATURED:
          return this.sortProducts(this.featuredProducts)
        case Category.ALL:
          return this.sortProducts(this.products)
        case Category.INTERIOR:
          return this.sortProducts(this.interiorProducts)
        case Category.EXTERIOR:
          return this.sortProducts(this.exteriorProducts)
        case Category.PACKAGE:
          return this.sortProducts(this.packages)
      }
      return []
    }
  },        
  methods: { 
    updateStore(filterParameter: string) {
      if (!(filterParameter.length > 0)) {
        filterParameter = ''
      }
      this.$store.commit('products/setFilterParameter', filterParameter)
    },
    sortProducts(products: Product[]) : Product[] {
      switch(this.sortBy) {
        case 'Name (A-Z)':
          return products.sort(this.nameSort)
        case 'Name (Z-A)':
          return products.sort(this.nameSort).reverse()
        case 'Price (High - Low)':
          return products.sort(this.priceSort)
        case 'Price (Low - High)':
          return products.sort(this.priceSort).reverse()
      }
    },
    nameSort(a: Product, b: Product) {
      return a.name >= b.name ? 1 : -1
    },
    priceSort(a: Product, b: Product) {
      return a.price >= b.price ? -1 : 1
    },
  },
  mounted() {
    bus.$on('filteringProducts', this.updateStore)
  },
  components: {
    ProductCard,
    ModelsList,
    YearModelSelector
  },
  props: ['category', 'sortBy']  
})
